<template>
  <div class="in-out-info mb-8">
    <div class="left-side">
      <div class="box">
        <vx-card>
          <div class="title">Current Occupancy</div>
          <div class="value text-blue">{{ data.countTotal }}</div>
          <div class="icon-grid">
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.totalPerson }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.totalCar }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.totalMotorcycle }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.totalOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="box">
        <vx-card>
          <div class="title">Entries</div>
          <div class="value text-green"><font-awesome-icon icon="fa-solid fa-arrow-up" /> {{ data.countIn }}</div>
          <div class="icon-grid">
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.inPerson }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.inCar }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.inMotorcycle }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.inOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="box">
        <vx-card>
          <div class="title">Exits</div>
          <div class="value text-red"><font-awesome-icon icon="fa-solid fa-arrow-down" /> {{ data.countOut }}</div>
          <div class="icon-grid">
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-person" />
              <span class="ml-2">{{ data.outPerson }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-car" />
              <span class="ml-2">{{ data.outCar }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-motorcycle" />
              <span class="ml-2">{{ data.outMotorcycle }}</span>
            </div>
            <div class="icon-item">
              <font-awesome-icon icon="fa-solid fa-truck" />
              <span class="ml-2">{{ data.outOtherVehicle }}</span>
            </div>
          </div>
        </vx-card>
      </div>
      <!-- <vs-tooltip text="Show Counting Chart">
          <div class="box flex items-center justify-center toggle-chart" @click="toggleChart">
            <font-awesome-icon icon="fa-solid fa-chart-column" class="large-faicon" />
          </div>
        </vs-tooltip> -->
      <vs-tooltip text="Download Daily Report">
        <div class="box flex items-center justify-center toggle-chart" @click="showPopupSelectDateReport = true">
          <font-awesome-icon icon="fa-solid fa-file-lines" class="large-faicon" />
        </div>
      </vs-tooltip>
    </div>
    <div class="right-side" v-show="showPrint">
      <vs-tooltip text="Print Chart">

        <div class="box flex items-center justify-center toggle-chart" @click="printChart()">
          <feather-icon icon="PrinterIcon" class="m-0" svgClasses="icon" />
        </div>
      </vs-tooltip>
      <!-- <div class="box flex items-center justify-center toggle-chart" @click="$emit('csv')">
          <feather-icon
                icon="FileTextIcon"
                class="m-0"
                svgClasses="icon"
              />
          </div> -->
    </div>

    <vs-prompt title="Export CSV" @cancel="cancelExport" @accept="submitExportCsv" @close="cancelExport"
      :is-valid="validInputReport" :active.sync="showPopupSelectDateReport">
      <p>Download daily report (csv)</p>
      <div class="vx-row pt-4">
        <div class="vx-col sm:w-1/2 w-full mb-3">
          <datepicker placeholder="Start Date" :disabledDates="disabledDates" v-model="datestart"></datepicker>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-3">
          <datepicker placeholder="End Date" :disabledDates="disabledDates" v-model="dateend"></datepicker>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
export default {
  props: ['data'],
  data() {
    return {
      disabledDates: {
        from: new Date()
      },
      showPrint: false,
      showPopupSelectDateReport: false,
      datestart: null,
      dateend: null
    }
  },
  components: {
    Datepicker
  },
  computed: {
    validInputReport() {
      if (this.datestart != null && this.dateend != null) {
        return true
      }
      return false
    }
  },
  methods: {
    toggleChart() {
      this.showPrint = !this.showPrint
      this.$emit('togglechart')
    },
    printChart() {
      window.print();
    },
    submitExportCsv() {
      this.$emit('downloadDailyReport', { 'start': this.datestart, 'end': this.dateend })
    },
    cancelExport() {
      this.showPopupSelectDateReport = false
      this.datestart = null
      this.dateend = null
    }
  }
}
</script>

<style lang="scss" scoped>
.in-out-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .left-side {
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 16px;
  }

  .right-side {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 16px;
  }

  .box {
    // background-color: #FFFFFF;
    flex: 1 1 calc(25% - 16px);
    min-width: 200px;
    // border: 2px solid #1372ac;
    border-radius: 10px;

    &.toggle-chart {
      flex: 0 0 54px;
      width: 54px;
      height: 54px;
      min-width: 54px;
      cursor: pointer;
      margin-right: 0;
    }

    .title {
      font-size: 12pt;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .value {
      font-weight: 700;
      font-size: 20pt;
      margin-bottom: 12px;
    }

    .icon {
      width: 32px;
      height: 32px;
      color: #1372ac;
    }

    // Responsive icon grid
    .icon-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: space-between;

      .icon-item {
        display: flex;
        align-items: center;
        flex: 0 1 auto;
        min-width: 45%;
        
        @media (min-width: 768px) {
          min-width: auto;
        }
      }
    }
    .icon-grid::before {
      display: none;
    }
  }

  .large-faicon {
    font-size: 32px;
    color: #1372ac;
  }

  // Responsive breakpoints
  @media (max-width: 1200px) {
    .box {
      flex: 1 1 calc(33.333% - 16px);
    }
  }

  @media (max-width: 992px) {
    .box {
      flex: 1 1 calc(50% - 16px);
    }
  }

  @media (max-width: 768px) {
    .left-side {
      width: 100%;
    }

    .box {
      flex: 1 1 100%;
      margin-right: 0;
      margin-bottom: 0px;

      .title {
        font-size: 11pt;
      }

      .value {
        font-size: 18pt;
      }
    }
  }

  @media (max-width: 480px) {
    .box {
      .icon-grid {
        .icon-item {
          min-width: 100%;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>